const KEY_PREFIX = 'web.admin.channel.users.all.table.assignCompanyRole';

type AssignResult = {
  userId: string;
  success: boolean;
  skippedCompanyIds?: ReadonlyArray<string> | null;
};

type UserCompany = { _id: string; name: string };

type AssignCompanyRoleOutcome = {
  key: string;
  companies: string;
  isAssigned: boolean;
};

export function getAssignCompanyRoleOutcome(
  results: ReadonlyArray<AssignResult> | null | undefined,
  userId: string,
  userCompanies: ReadonlyArray<UserCompany>
): AssignCompanyRoleOutcome {
  const result = results?.find(candidate => candidate.userId === userId);
  const isAssigned = result?.success ?? false;
  const skippedNames = (result?.skippedCompanyIds ?? []).map(
    skippedId =>
      userCompanies.find(({ _id }) => _id === skippedId)?.name ?? skippedId
  );

  if (skippedNames.length === 0) {
    return {
      key: `${KEY_PREFIX}.${isAssigned ? 'success' : 'notAssigned'}`,
      companies: '',
      isAssigned,
    };
  }

  return {
    key: `${KEY_PREFIX}.${isAssigned ? 'successSkipped' : 'notAssignedSkipped'}`,
    companies: skippedNames.join(', '),
    isAssigned,
  };
}
